// JS file for LocationList

import '@main';

u.$ui.bootstrap.tooltip();

$('#input-q').on('input', function () {
  let val = $(this).val();
  const icon = $('.j-search-wrapper').children('.c-select-icon');

  if (val) {
    icon.addClass('d-none');
  } else {
    icon.removeClass('d-none');
  }
});

// u.$ui.choices('.c-choices select');
